import {
  COMBINE_GROUP_BAZAAR_LIST_FAILURE,
  COMBINE_GROUP_BAZAAR_LIST_REQUEST,
  COMBINE_GROUP_BAZAAR_LIST_RESET,
  COMBINE_GROUP_BAZAAR_LIST_SUCCESS,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const combineGroupBazaarListReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMBINE_GROUP_BAZAAR_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case COMBINE_GROUP_BAZAAR_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      }

    case COMBINE_GROUP_BAZAAR_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      }

    case COMBINE_GROUP_BAZAAR_LIST_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default combineGroupBazaarListReducer
